import { Injectable } from '@angular/core';


// The variable below will be provided by the _Index.cshtml file
var wresources = (<any>window).bsvNewsletterResources;
@Injectable()
export class ResourceService {
  resources = wresources;
}